import { asyncComponent } from '@/components/asyncComponent'
const Calendar = asyncComponent(() => import('./Calendar'))
export {
  Calendar
}



// WEBPACK FOOTER //
// ./src/components/Calendar/index.js